
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands, commonRouterPush } from "@common/src/utils/common";
import { Table } from "@common/src/utils/decorator";
import QRCode from "qrcodejs2";
import dayjs from "dayjs";
import StandardFlag from "@common/src/components/scope/standard-flag/index.vue";
import QrCode from "@common/src/components/scope/qr-code/index.vue";
import CampaignQrCode from "./components/campaign-qr-code.vue";
import { InjectFunction } from "@common/src/utils/decorator";
import t from "@common/src/i18n/t";
const base = namespace("base");
const store = namespace("store");
const campaign = namespace("campaign");
const marketing = namespace("marketing");
@InjectFunction("dayjs", "permitApp", "appCode")
@Component({
  components: { StandardFlag, QrCode, CampaignQrCode }
})
@Table("loadListData")
export default class ServiceList extends Vue {
  dayjs = dayjs;
  @base.Action getDictionaryList;
  @campaign.Action queryCampaignList;
  @campaign.Action updateCampaignBeEnd;
  @store.State storeData;
  @marketing.Action queryFissionPage;
  @marketing.Action getFissionQrCodeUrlV2;
  @marketing.Action getWxSchemeUrl;
  @marketing.Action stopCampaign;
  @marketing.Action synchronizeStores;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  commonRouterPush = commonRouterPush;
  t = t;
  orderList: any[] = [];
  searchForm = {
    campaignName: "",
    campaignStatus: ""
  };
  h5FissionUrl: string = ""; //h5活动裂变url
  showComfirmPayment: boolean = false;
  showRegisterInvoice: boolean = false;
  showLinkQr: boolean = false;
  orderStatusList: any[] = [];
  staffList: any[] = [];
  storeList: any[] = [];
  created() {
    this.init();
    this.loadListData();
  }
  init() {
    // 活动状态枚举值
    this.getDictionaryList("campaign_status").then(data => {
      this.campaignStatusList = data;
    });
    this.getDictionaryList("store_type").then(data => {
      this.storeList = data;
    });
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryFissionPage({
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.orderList = data.data.list;
      return data;
    });
  }
  get searchList() {
    return [
      {
        label: t("v210801.activity-name"),
        type: "input",
        value: "",
        prop: "campaignName"
      },
      {
        label: t("v210801.active-state"),
        type: "select",
        selectList: this.campaignStatusList,
        value: "",
        prop: "campaignStatus"
      },
      ...(this.appCode === "speedbiz-operation"
        ? [
            {
              label: t("v210801.applicable-stores"),
              type: "select",
              selectList: this.storeList,
              value: "",
              prop: "storeType"
            }
          ]
        : [])
    ];
  }
  campaignStatusList: any = [];
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  qrCode(url) {
    document.getElementById("qrcode").innerHTML = "";
    let qrcode = new QRCode("qrcode", {
      width: 120, //图像宽度
      height: 120, //图像高度
      colorDark: "#000000", //前景色
      colorLight: "#ffffff", //背景色
      typeNumber: 4,
      correctLevel: QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
    });
    qrcode.clear(); //清除二维码
    qrcode.makeCode(url); //生成另一个新的二维码
  }
  activeRow: any = {};
  qrData: any = {};
  handleComfirmCommand(command, row) {
    if (command === "push") {
      this.$router.push(`/marketing/campaign/fission-send-collect/${row.campaignCode}`);
    } else if (command === "edit") {
      this.$router.push(`/marketing/campaign/fission-campagin-add/${row.campaignCode}`);
    } else if (command === "end") {
      this.activeRow = row;
    } else if (command === "copy") {
      this.$router.push(`/marketing/campaign/fission-campagin-add?copyCode=${row.campaignCode}`);
    } else if (command === "copyLink") {
      console.log("[=============  ]");
      this.activeRow = row;
      this.showLinkQr = true;
      let page = "pages/index/index";
      this.getFissionQrCodeUrlV2({
        campaignCode: row.campaignCode,
        page
      }).then(data => {
        this.qrData = data.data;
      });
    }
  }
  handleEndCampaign() {
    this.stopCampaign({
      campaignCode: this.activeRow.campaignCode
    }).then(() => {
      this.$message.success(t("v210831.activity-ended"));
      this.loadListData();
    });
  }
  handleLinkData(row) {
    this.$router.push(`/marketing/campaign/fission-analysis/${row.campaignCode}?campaignType=collect`);
  }
  handleLinkOrderView(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}`
    });
    window.open(href, "_blank");
  }
  tipCopy() {
    this.$message.success(t("v210831.copy-succeeded"));
  }
  async syncClick(item) {
    const res = await this.synchronizeStores({ campaignCode: item.campaignCode });
    if (res.code === "0") {
      this.$message.success(t("v210831.synchronization-succeeded"));
      this.loadListData();
    }
  }
}
